/**
 * An item's full path — the one spelling of it, for both sides (MAR-948 wave 3).
 *
 * An item's place in its tree is two columns: `path`, its parent folder's full path, and its own
 * `slug`. A folder's children are the rows whose `path` equals the folder's FULL path, so this is
 * the join key of the whole tree, and every hand-rolled copy of it was one `'/'` special case away
 * from `//contratos`. The server's normalization and tree predicates live in
 * `server/services/items/paths.ts`; the SQL spelling of this same expression is `ITEM_FULL_PATH_SQL`
 * there.
 */
export function fullPathOf(item: { path?: string | null, slug?: string | null }): string {
  const path = item.path ?? '/'
  const slug = item.slug ?? ''
  return path === '/' ? `/${slug}` : `${path}/${slug}`
}

/**
 * Whether a path lies under a reserved library folder such as `/__templates__` (MAR-1467) — any
 * segment that starts with a double underscore. Reserved folders hold system rows (a materialized
 * template, `server/services/workflows/templateResolver.ts`) that no user can open, so their path is
 * never shown to the chat model: on dev it repeated `/__templates__` to a user as "el repositorio
 * interno de Marcus". `services/agent-web-chat`'s `server_tools._is_reserved_path` applies the same
 * rule to the document listing.
 */
export function isReservedItemPath(path: string | null | undefined): boolean {
  return (path ?? '').split('/').some(segment => segment.startsWith('__'))
}
